import api from "../../../api";
import urls from "../../../urls";

export async function resendOtp(method: string, email: string) {
  await api.publicRequest("POST", urls.auth.generate2FaCode(), {
    method,
    email
  });
}
